import Axios from 'axios';
import Cookies from 'js-cookie';

const http = Axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL  
});

http.interceptors.request.use((requestConfig) => {
  try {
    const token = Cookies.get('token');
    if (requestConfig && requestConfig.headers) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
  } catch (err) {
    console.log(err);
  }
  return requestConfig;
});

http.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    console.log('Error occurs at api call: ', err.response);
    const apiError = new Error(err.response?.data?.errorMsg || 'Request failed');
    apiError.response = err.response;
    apiError.status = err.response?.status;
    throw apiError;

    // if (err.response.status === 401) {
    //   // Do some stuff
    // }
  },
);

export default http;
